"use strict";

exports.__esModule = true;
exports.VisuallyHidden = void 0;

var _styled = require("@manifest-ui/styled");

var _themeUtils = require("@manifest-ui/theme-utils");

const VisuallyHidden = (0, _styled.styled)('span', {
  label: 'VisuallyHidden',
  themeKey: 'visuallyHidden'
})(_themeUtils.visuallyHiddenStyles);
exports.VisuallyHidden = VisuallyHidden;